export default {
  general: {
    back: 'アカウントに戻る',
    backFarm: 'ファームに戻る',
  },
  user: {
    settings: 'アカウント設定'
  },
  summary: {
    title: '財務',
    yesterday: '昨日の収益',
    total: '全期間の収益',
    withdrawn: '出金済み',
    balance: '残高',
    withdrawNow: '出金',
    income: "Income",
    todayEstimate: "Today’s estimate:",
    finance: "Finance",
    incomeHistory: "Income history",
    withdrawalHistory: "Withdrawal history",
    totalIncomeHint1: "Total income does not includes today income",
    totalIncomeHint2: "Today income will be credited to your balance at 00:00 UTC (London time)",
  },
  farms: {
    title: 'あなたのファーム',
    share: 'あなたのシェア',
    yesterday: '昨日の収益',
    total: '全期間の収益',
    view: '詳細'
  },
  table: {
    total: '合計',
    noData: '記録が見つかりません'
  },
  income: {
    title: '収益履歴',
    amount: '金額',
    date: '日付',
    farm: 'ファーム',
  },
  withdrawals: {
    title: '出金履歴',
    amount: '金額',
    date: '日付',
    address: 'アドレス',
    status: 'ステータス',
    pending: '保留中',
    paid: '完了',
    withdrawNow: '新しい出金'
  },
  account: {
    title: 'アカウント設定',
    enterName: 'あなたの名前',
    saveChanges: '変更を保存する',
    changesSaved: '変更が保存されました',
    saving: '保存中...',
    retypeNewPassword: 'パスワードを再入力してください',
    passwordSaved: '新しいパスワードが保存されました',
    deleteAccount: 'アカウントを削除しますか？',
    contactSupport: 'サポートに連絡する',
    questions: '注文に関する質問はありますか？',
    getHelp: 'ヘルプが必要です',
    wrongPassword: 'パスワードが間違っています',
    oldPassword: '旧パスワード',
    min6chars: '最低6文字',
    newPassword: '新しいパスワード',
    loginMethods: 'ログイン方法',
    viaPassword: "パスワード",
    viaSocial: 'による認証 ',
    enterCurrentPassword: '現在のパスワードを入力してください',
    change: '変更',
    remove: '削除',
    setPassword: '作成',
    removeWarning: 'パスワードを削除すると、Google経由でのみログインできます',
    removePassword: 'パスワードを削除する',
    removingPassword: 'パスワードを削除しています...',
    cancel: 'キャンセル',
    disable: '無効にする',
    enable: '有効にする',
    twitterTokenAccess: 'Twitter Bot Access Token',
    generateToken: 'Generate Token',
    deleteToken: 'Delete Token',
  },
  farmInfo: {
    'deviceDetails': 'デバイスの詳細',
    'model': 'モデル',
    'hashrate': 'ハッシュレート',
    'power': 'パワー',
    'watts': 'ワット',
    'price': '価格',
    'desc': 'グループ マイニング ファーム「%miniFarmTitle%」は %devices% で構成されています。 最も人気のあるマイニングマシンの1つです。',
    'desc2': 'あなたは Xive のパートナーとなり、以下に基づいて "%miniFarmTitle%" ファームを共同所有します。 ' +
      '購入したシェアの割合。 ' +
      'デバイスとホスティングの価格は Xive の原価と同じです。 ',
    'desc3': 'Xive は、生成された利益に対して %miniFarmServiceFee% の管理手数料のみを適用します。',
    'deviceDesc': '%model% の %count% デバイス、それぞれハッシュレート %rate%',
    'groupMiningDetails': 'グループマイニングファームの詳細',
    'totalHashrate': '合計ハッシュレート',
    'totalValue': '合計値',
    'devices': 'デバイス',
    'hostingDetails': 'ホスティングの詳細',
    'electricityFee': 'ホスティング料金',
    'kwh': 'kW/h',
    'securityDeposit': 'デポジット',
    'days': '日',
    'profitSharing': '利益配分',
  },
  farmSummary: {
    title: '財務',
    yesterday: '昨日の収益',
    total: '累計収益',
    deposit: 'デポジット',
    stake: 'ファームのシェア'
  },
  farmIncome: {
    title: '収益履歴',
    amount: '金額',
    date: '日付'
  },
  farmOrders: {
    title: '購入履歴',
    date: '日付',
    stake: 'ファームのシェア',
    amount: '価格',
    deposit: 'デポジット'
  },
  withdrawal: {
    sendBtc: 'ビットコインの出金',
    loadingBalance: 'バランスの読み込み中...',
    network: 'ネットワーク:',
    selectNetwork: 'ネットワークを選択してください',
    bitcoinNetwork: 'Bitcoinネットワーク',
    binanceNetwork: 'BNB Smart Chain (BEP20)',
    address: 'アドレス:',
    invalidAddress: '無効なアドレスです',
    walletOk: 'アドレスOK',
    mainnetRequired: 'MainNetウォレットが必要です',
    mustBeBitcoinNetwork: 'ウォレットアドレスは有効な<b>Bitcoinネットワーク</b>アドレスである必要があります',
    mustBeBinanceNetwork: 'ウォレットアドレスは有効な<b>Binance BEP 20（BSC）</b>アドレスである必要があります',
    transactionsIrreversible: 'すべてのBitcoinトランザクションは不可逆です。誤った' +
      'Bitcoinアドレスを入力すると資金が<b>失われます</b>！',
    sendFrom: '送信元:',
    selectWallet: 'ウォレットを選択してください',
    amount: '金額:',
    max: '最大',
    available: '利用可能:',
    minAmount: '最小金額:',
    notEnoughBalance: '出金には残高が不足しています',
    receiveAmount: '受け取る金額:',
    calculating: '計算中...',
    networkFee: '手数料',
    continue: '続行する',
    checking: '確認中...',
    confirmWithdrawal: '出金の確認',
    verifyWithdrawal: '出金を確認してください',
    sixDigitsSent: '6桁のコードがメールアドレスに送信されましたので、メールをご確認ください',
    confirm: '確認する',
    withdrawalRequested: '出金が確認されました',
    willBeWithdrawn: 'リクエストされた金額は数時間以内に送金されます',
    close: '閉じる',
    wrongCode: '無効なコードが入力されました。コードを確認してください',
    enterCryptoAddress: '暗号通貨ウォレットを入力してください',
    enterAmount: '金額を入力してください',
  }
}